import React, { lazy } from 'react';

/* PLOP_INJECT_MODULE_ROUTES_IMPORT */
const Posts = React.lazy(() => import("posts"));
const Admin = React.lazy(() => import("admin"));
const Tweets = React.lazy(() => import("tweets"));
const Archive = React.lazy(() => import('archive'));
const Notifications = React.lazy(() => import('notifications'));
const Reports = React.lazy(() => import('reports'));
const Settings = React.lazy(() => import('settings'));
const Dashboard = React.lazy(() => import('dashboard'));
const Organization = React.lazy(() => import('organization'));
const Topics = React.lazy(() => import('topics'));
const News = React.lazy(() => import('news'));
const Videos = React.lazy(() => import('videos'));
const Users = React.lazy(() => import('users'));
const Sets = React.lazy(() => import('sets'));
const Hashtags = lazy(() => import('hashtags'));

const InfluencersEntities = lazy(() => import('influencers'));
const Trends = lazy(() => import('trends'));
const Auth = lazy(() => import('auth'));
const ErrorsPage = lazy(() => import('./pages/ErrorsPage/ErrorsPage'));
const Analyzing = lazy(() => import('./pages/Analyzing/Analyzing'));

import { AppRoute } from './utils/types';

const RootRoutes: Array<AppRoute> = [
  /* PLOP_INJECT_MODULE_ROUTES */

    {
      path: "/posts",
      component: Posts
    },

    {
      path: "/admin",
      component: Admin
    },

    {
      path: "/tweets",
      component: Tweets
    },

  {
    path: '/archive',
    component: Archive,
  },

  {
    path: '/notifications',
    component: Notifications,
  },

  {
    path: '/reports',
    component: Reports,
  },

  {
    path: '/settings',
    component: Settings,
  },

  {
    path: '/dashboard',
    component: Dashboard,
  },

  {
    path: '/organizations',
    component: Organization,
  },

  {
    path: '/topics',
    component: Topics,
  },

  {
    path: '/news',
    component: News,
  },

  {
    path: '/videos',
    component: Videos,
  },

  {
    path: '/users',
    component: Users,
  },
  {
    path: '/sets',
    component: Sets,
  },

  {
    path: '/hashtags',
    component: Hashtags,
  },

  {
    path: '/influencers',
    component: InfluencersEntities,
  },
  {
    path: '/entities',
    component: InfluencersEntities,
  },

  {
    path: '/trends',
    component: Trends,
  },

  {
    path: '/auth',
    component: Auth,
  },
  {
    path: '/analyzing',
    component: Analyzing,
  },
  {
    path: '/:status',
    component: ErrorsPage,
  },
  {
    path: '/',
    component: Dashboard,
    exact: true,
  },
];
export default RootRoutes;
